export default __webpack_public_path__ + "static/media/loader_cow_light.500c598c.gif";